import {Note} from "types/Note";
import {dateTime} from "services/date";

/**
 * Transform the given note by deserializing object properties
 *
 * @internal
 * @param note
 */
export default function deserializeNote(note: any): Note {
    // note.author = deserializeUser(note.author)
    note.expires_at = dateTime(note.expires_at)
    note.created_at = dateTime(note.created_at)
    note.updated_at = dateTime(note.updated_at)

    return note;
}